function SectionHeader({ label, title }) {
  return (
    <div className="section-header">
      <p>{label}</p>
      <h2>{title}</h2>
    </div>
  );
}

export default SectionHeader;
